import React from 'react';
import PropTypes from 'prop-types';
import { PlanLoaderProgressV7 } from '../PlanLoaderProgressV7';

const DELAY = 800;

function PlanLoaderSlideV8({ onContinue, heading, steps, reviews }) {
    const finishProgress = () => {
        setTimeout(() => {
            onContinue();
        }, DELAY);
    };

    return (
        <PlanLoaderProgressV7
            finish={finishProgress}
            heading={heading}
            steps={steps}
            reviews={reviews}
        />
    );
}

PlanLoaderSlideV8.propTypes = {
    onContinue: PropTypes.func.isRequired,
    heading: PropTypes.string,
    steps: PropTypes.arrayOf(PropTypes.string),
    reviews: PropTypes.array
};

export {
    PlanLoaderSlideV8
};
